import { FC } from "react";
import { IconProps } from "./types";

export const SocialX: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="m13.6 10.684 6.262-7.279h-1.484l-5.437 6.32-4.343-6.32H3.59l6.567 9.557-6.567 7.633h1.484l5.742-6.674 4.586 6.674h5.008l-6.81-9.91zm-2.032 2.363-.665-.952-5.295-7.573h2.28l4.272 6.112.665.951 5.554 7.944h-2.28l-4.531-6.482z"
      fill={fill}
    />
  </svg>
);
